import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ApartmentService } from 'src/app/_services/apartments/apartment.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { InquiresService } from 'src/app/_services/inquires/inquires.service';
import { finalize } from 'rxjs';


// ---- API shapes (كما في الريسبونس) ----
type ApiHandover = {
  handover_ID: string;
  places: ApiPlace[];
};
type ApiPlace = {
  place_ID: string;
  place_Name: string;
  place_Images: string[];
  handover_Questions_Json: string; // JSON string
  comments: ApiComment[];
};
type ApiComment = {
  id: string;
  booking_ID: string,
  guest_ID: string,
  comment: string;
  attachments: string[];
  approved: boolean;
};

// ---- UI shapes (للعرض في التمبليت الحالي) ----
type UIHandover = { places: UIPlace[] };
type UIPlace = {
  place_ID: string;
  place_Name: string;
  place_Images: string[];
  questions: UIQuestion[];
  comments: ApiComment[];
};
type UIQuestion = { question: string; answer: 'yes' | 'no'; images: string[] };



// ------ DUMMY API DATA -------
const DUMMY_API: ApiHandover = {
  handover_ID: 'HO-001',
  places: [
    {
      place_ID: 'pl-kitchen',
      place_Name: 'Kitchen',
      place_Images: [
        'https://picsum.photos/seed/course1/550/320',
        'https://picsum.photos/seed/course1/550/320',
        'https://picsum.photos/seed/course1/550/320',
        'https://picsum.photos/seed/course1/550/320'
      ],
      handover_Questions_Json: JSON.stringify([
        {
          question: 'Cabinets and drawers are in good condition',
          answer: 'yes',
          images: []
        },
        {
          question: 'Sink is working properly without leaks',
          answer: 'no',
          images: ['https://picsum.photos/seed/course1/550/320', 'https://picsum.photos/seed/course1/550/320']
        },
        {
          question: 'Heating system is working correctly',
          answer: 'yes',
          images: []
        }
      ]),
      comments: [
        {
          id: 'c1',
          booking_ID: 'c1',
          guest_ID: 'c1',

          comment:
            'The apartment was generally in good condition, but the kitchen sink was clogged and had a bad smell.',
          attachments: ['https://picsum.photos/seed/course1/550/320'],
          approved: true
        },
         {
          id: 'c1',
           booking_ID: 'c1',
          guest_ID: 'c1',
          comment:
            'The apartment was generally in good condition, but the kitchen sink was clogged and had a bad smell.',
          attachments: ['https://picsum.photos/seed/course1/550/320'],
          approved: true
        }
      ]
    },
    {
      place_ID: 'pl-bath',
      place_Name: 'Bathroom',
      place_Images: [
        'https://picsum.photos/seed/course1/550/320',
        'https://picsum.photos/seed/course1/550/320',
        'https://picsum.photos/seed/course1/550/320'
      ],
      handover_Questions_Json: JSON.stringify([
        { question: 'Shower works correctly', answer: 'yes', images: [] },
        { question: 'No mold on tiles', answer: 'yes', images: [] },
        { question: 'Mirror is clean', answer: 'no', images: ['https://picsum.photos/seed/course1/550/320'] }
      ]),
      comments: [
        {
          id: 'c2',
           booking_ID: 'c1',
          guest_ID: 'c1',
          comment: 'Mirror has stains; needs cleaning.',
          attachments: ['https://picsum.photos/seed/course1/550/320'],
          approved: true
        }
      ]
    },
    {
      place_ID: 'pl-living',
      place_Name: 'Living Room',
      place_Images: ['https://picsum.photos/seed/course1/550/320', 'https://picsum.photos/seed/course1/550/320'],
      handover_Questions_Json: JSON.stringify([
        { question: 'Windows close properly', answer: 'yes', images: [] },
        { question: 'Floor is intact', answer: 'yes', images: [] }
      ]),
      comments: [{ id: 'c3', booking_ID: 'c1',
          guest_ID: 'c1', comment: 'All good.', attachments: [], approved: true }]
    }
  ]
};

@Component({
  selector: 'app-view-handover',
  templateUrl: './view-handover.component.html',
  styleUrls: ['./view-handover.component.scss']
})
export class ViewHandoverComponent {
  trackByIndex(index: number): number { return index; }

	showSide: string = '';

    items = [
    { label: 'View Details' }
  ];

  // handover:any;

  constructor(
    private apartmentService: ApartmentService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private _inquiresService:InquiresService,
    
  ) {}
// ------ mapping من API -> UI ------
mapApiToUI(api: ApiHandover): UIHandover {
  return {
    places: api.places.map((p) => ({
      place_ID: p.place_ID,
      place_Name: p.place_Name,
      place_Images: p.place_Images ?? [],
      questions: this.safeParseQuestions(p.handover_Questions_Json),
      comments: p.comments  ?? []
    }))
  };
}

safeParseQuestions(json: string): UIQuestion[] {
  try {
    const arr = JSON.parse(json) as any[];
    return arr.map((q) => ({
      question: q.question,
      answer: (q.answer === true || q.answer === 'yes') ? 'yes' : 'no',
      images: q.images ?? []
    }));
  } catch {
    return [];
  }
}

 
handover: UIHandover = { places: [] };
showProblems: Record<string, boolean> = {}; 
currentHandover: any; 

ngOnInit() {

  const qp = this.route.snapshot.queryParamMap;

  // IDs
  this.bookingId = qp.get('bookingId');
  this.tenantId  = qp.get('tenantId');

  // JSON
  const raw = qp.get('currentHandover');
  this.currentHandover = raw ? JSON.parse(raw) : null;
  console.log(this.currentHandover, this.bookingId, this.tenantId )

  
  // this.handover = this.mapApiToUI(DUMMY_API);
  this.handover = this.mapApiToUI(this.currentHandover);
  console.log(this.handover, this.mapApiToUI(DUMMY_API))

}

getIconNamee(place?: string): string {
  const key = (place || '').toLowerCase();
  if (key.includes('kitchen')) return 'assets/images/handover/icons/kitchen.svg';
  if (key.includes('bath')) return 'assets/images/handover/icons/bathroom.svg';
  if (key.includes('living')) return 'assets/images/handover/icons/living.svg';
  if (key.includes('bed')) return 'assets/images/handover/icons/bedroom.svg';
  return 'assets/images/handover/icons/other.svg';
}

 getIconName(placeName: string = ''): string {
  const name = placeName.toLowerCase().trim();

  switch (true) {
    // Bedrooms: يلقط أي صيغ شائعة
    case /bedroom|bed room|single|double|triple|trible|shared/.test(name):
      return '/assets/images/bedroomIcon.svg';

    // Bathroom / WC / Toilet
    case /bath|toilet|wc/.test(name):
      return '/assets/images/bathIcon.svg';

    // Living room / Reception / Salon
    case /living|reception|salon/.test(name):
      return '/assets/images/livingIcon.svg';

    // Kitchen
    case /kitchen|kitch/.test(name):
      return '/assets/images/KitchenIcon.svg';

    default:
      return '/assets/images/KitchenIcon.svg'; // fallback
  }
}

toggleProblems(id: string) {
  this.showProblems[id] = !this.showProblems[id];
}

hasProblems(place: UIPlace): boolean {
  // return place.questions.some((q) => q.answer === 'no');
  return place.comments.length >0 ;

}
   	addItem(value: string): void {
		this.showSide = value;
	}


  //////////////////////////////////////////////////////////////
 
  display1: 'none' | 'block' = 'none';

   
  Reason = '';

   loading = false;
  

   selectedCommentId: string | null = null;

  

  // فتح مودال الرفض مع حفظ الـ id
  onOpenRejectModal(commentId?: string): void {
    if (!commentId) { console.warn('No comment id'); return; }
    this.selectedCommentId = commentId;
    this.display1 = 'block';
    document.body.style.overflow = 'hidden';
  }

   
  onCloseModal1(): void {
    this.display1 = 'none';
    document.body.style.overflow = '';
     
  }

   
  // تأكيد الرفض (زر confirm داخل المودال)
  CancelRequest(): void {
    const id = this.selectedCommentId;
    const reason = (this.Reason || '').trim();

    if (!id) { console.warn('No selected comment id'); return; }
    if (!reason) { alert('Please enter a rejection reason.'); return; }

    this.loading = true;
    this._inquiresService.rejectHandoverComment(id, reason)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => {
          // TODO: حدثي الـ UI/اعملي refresh للقائمة
          this.onCloseModal1();
				this.messageService.add({ severity: 'success', summary: 'Confirmed', detail:  `${res.message || 'Booking Rejected Successfully'}` });

        },
        error: (err) => {
          console.error('Reject failed', err);
				this.messageService.add({ severity: 'error', summary: 'Error', detail:  `${err.error.message || 'error, please try again'}` });

        }
      });
  }



  
  // الموافقة
  approve(commentId?: string): void {
    const id = commentId ?? this.selectedCommentId;
    if (!id) { console.warn('No comment id'); return; }

    this.loading = true;
    this._inquiresService.approveHandoverComment(id)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => {
          // TODO: حدثي الـ UI/اعملي refresh
				this.messageService.add({ severity: 'success', summary: 'Confirmed', detail:  `${res.message || 'Booking Approved Successfully'}` });

          console.log('Approved');
        },
        error: (err) => {
          console.error('Approve failed', err);
				this.messageService.add({ severity: 'error', summary: 'Error', detail:  `${err.error.message || 'error, please try again'}` });

        }
      });
  }


  bookingId:any;
  tenantId:any;
  createHandover() {
  this.loading = true;
  this._inquiresService 
    .generateHandoverTenant(this.bookingId, this.tenantId)
    .subscribe({
      next: res => {
        // success UI/refresh
				this.messageService.add({ severity: 'success', summary: 'Confirmed', detail:  `${res.message || 'Marked as Completed Successfully'}` });

      },
      error: err =>{
				this.messageService.add({ severity: 'error', summary: 'Error', detail:  `${err.error.message || 'error, please try again'}` });

         console.error(err)
        },
    })
    .add(() => (this.loading = false));
}

}
